/**
 * subscribedFrom values sent to the CRM with an email subscribe, keyed by the appearsOn placement
 * the signup rendered in. appearsOn is the placement vocabulary the acquisition banners already
 * share with the adverts API (`appears_on`), so a placement has one context wherever its component
 * is reused - keep the keys describing where on the site the signup appears, never which component
 * or layout renders it
 */
const CONTEXT_MAP = {
  home_usp: 'nlmodule_tophomepage',
  home: 'nlmodule_midhomepage',
  black_friday: 'nlmodule_blackfriday',
  community: 'community',
  bundle: 'nlmodule_midbundle',
  category: 'nlmodule_midcategory',
  search: 'nlmodule_midsearch',
};

const DEFAULT_CONTEXT = 'nlmodule_tophomepage';

/**
 * The context an email subscribe from this placement should report
 * @param  {String} appearsOn Placement the signup renders in
 * @return {String}
 */
const getSubscribeContext = appearsOn => CONTEXT_MAP[appearsOn] ?? DEFAULT_CONTEXT;

export default getSubscribeContext;
